import { Link, Image } from '@chakra-ui/react'

export const Banner = ({ src, fallbackSrc, href, alt, gtmClick, ...props }) => {
  return (
    <Link href={href} {...(gtmClick && { 'data-gtm-click': gtmClick })}>
      <Image src={src} fallbackSrc={fallbackSrc} alt={alt} width="100%" {...props} />
    </Link>
  )
}
